export const amenityIcons: Record<string, string> = {
  "coffee maker": "☕",
  Coffee: "☕",
  "Baking sheet": "🍪",
  "Dishes and silverware": "🍽️",
  "Barbeque utensils": "🥩",
  "Hair Dryer": "༄",
  "Rice maker": "🍚",
  "Bread maker": "🍞",
  "Mini fridge": "❄️",
  "Iron & Ironing Board": "🚄",
};
